import React from 'react';
import { TileSlider } from '../TileSlider';
import { EventCard as EventCardV2 } from '../EventCard';
import { SliderCard } from '../../contracts';

import './index.scss';

// width of each tile for TileSlider calculations
const fixedTileWidth = 188;

export type SliderProps = {
    cards: SliderCard[];
    onClick: (id: string, name: string, isSgp: boolean) => void;
};

export type Slidertate = {
    sliderWidth: number;
};
export class Slider extends React.Component<SliderProps, Slidertate> {
    parentRef: HTMLDivElement | null = null;

    constructor(props: SliderProps) {
        super(props);

        this.state = {
            sliderWidth: 0
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.setWidth);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.setWidth);
    }

    setParentRef = (r: HTMLDivElement) => {
        if (!this.parentRef && r) {
            this.parentRef = r;
            this.setState({ sliderWidth: r.offsetWidth });
        }
    };

    setWidth = () => {
        if (this.parentRef) {
            this.setState({ sliderWidth: this.parentRef.offsetWidth });
        }
    };

    createCards = (cards: SliderCard[]) => {
        return cards.map((card: SliderCard) => {
            const handleClick = (e: React.MouseEvent) => {
                e.preventDefault();
                this.props.onClick(card.id, card.name, false);
            };

            return <EventCardV2 key={card.id} {...card} onClick={handleClick} />;
        });
    };

    render() {
        const { cards } = this.props;

        const tiles = this.createCards(cards);

        return (
            <div className="slider-cards" data-testid="slider-cards" ref={this.setParentRef}>
                <TileSlider
                    sliderWidth={this.state.sliderWidth + 200}
                    tileWidth={200}
                    scrollMode={this.state.sliderWidth <= 768}
                    tileWidths={tiles.map(() => fixedTileWidth)}
                    dynamicSlide
                    offset={0}
                    shouldCalculateContainerWidth
                >
                    {tiles}
                </TileSlider>
            </div>
        );
    }
}
